<template>
  <div class="markdown-quick-reference uk-margin">
    <a href="#" @click.prevent="showModal">{{$t('showHelp')}}</a>

    <modal
      ref="modal"
      title="Markdown-Formatierung"
      class="uk-modal-container"
      auto-overflow
    >
      <h3>Überschriften</h3>
      <div class="uk-grid-small uk-grid-match" uk-grid>
        <div class="uk-width-1-2">
          <pre>
# Überschrift 1
## Überschrift 2
### Überschrift 3</pre>
        </div>
        <div class="uk-width-1-2">
          <pre>
&lt;h1&gt;Überschrift 1&lt;/h1&gt;
&lt;h2&gt;Überschrift 2&lt;/h2&gt;
&lt;h3&gt;Überschrift 2&lt;/h3&gt;</pre>
        </div>
      </div>

      <h3>Text-Formatierung</h3>
      <div class="uk-grid-small uk-grid-match" uk-grid>
        <div class="uk-width-1-2">
          <pre>
**strong**
*italic*
_underlined_</pre>
        </div>
        <div class="uk-width-1-2">
          <pre>&lt;strong&gt;strong&lt;/strong&gt;
&lt;em&gt;italic&lt;/em&gt;
&lt;u&gt;underlined&lt;/u&gt;</pre>
        </div>
      </div>

      <h3>Links</h3>
      <div class="uk-grid-small uk-grid-match" uk-grid>
        <div class="uk-width-1-2">
          <pre>[link](http://www.example.com)</pre>
        </div>
        <div class="uk-width-1-2">
          <pre>&lt;a href="http://www.example.com"&gt;link&lt;/a&gt;</pre>
        </div>
      </div>

      <h3>Listen</h3>
      <div class="uk-grid-small uk-grid-match" uk-grid>
        <div class="uk-width-1-1">
          <h4>Unsortierte Liste</h4>
        </div>
        <div class="uk-width-1-2">
          <pre>
* List Item 1
* List Item 2
* List Item 3</pre>
        </div>
        <div class="uk-width-1-2">
          <pre>&lt;ul&gt;
  &lt;li&gt;List Item 1&lt;/li&gt;
  &lt;li&gt;List Item 2&lt;/li&gt;
  &lt;li&gt;List Item 3&lt;/li&gt;
&lt;/ul&gt;</pre>
        </div>

        <div class="uk-width-1-1">
          <h4>Sortierte Liste</h4>
        </div>
        <div class="uk-width-1-2">
          <pre>
1. List Item 1
2. List Item 2
3. List Item 3</pre>
        </div>
        <div class="uk-width-1-2">
          <pre>&lt;ol&gt;
  &lt;li&gt;List Item 1&lt;/li&gt;
  &lt;li&gt;List Item 2&lt;/li&gt;
  &lt;li&gt;List Item 3&lt;/li&gt;
&lt;/ol&gt;</pre>
        </div>
      </div>


    </modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal';

export default {
  name: 'markdown-quick-reference',
  components: {
    Modal,
  },
  methods: {
    showModal() {
      this.$refs.modal.show();
    },
  },
  i18n: {
    messages: {
      de: {
        showHelp: 'Hilfe zur Formatierung anzeigen',
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// MarkdownQuickReference.vue?41ca60e0